import { useGlobal } from '@/utils/useGlobal';
import styles from './index.module.scss';
import EFPicture from '@elem/ui/ef-picture';
import { Collapse, CollapseProps } from 'antd-v5';
import { useMemo, useState } from 'react';

const TriShield = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('OceanProHomeSolarBattery');
    const [active, setActive] = useState('0');
    const list = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1751277804486/TriShield1.jpg',
            title: t(`trishield_section_title1`),
            desc: t(`trishield_section_desc1`),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1751277846866/TriShield2.jpg',
            title: t(`trishield_section_title2`),
            desc: t(`trishield_section_desc2`),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1751277847016/TriShield3.jpg',
            title: t(`trishield_section_title3`),
            desc: t(`trishield_section_desc3`),
        },
    ];

    const img = useMemo(() => {
        return list[Number(active)]?.img;
    }, [active]);

    const changeActive = (v: any) => {
        if (v === active) {
            return;
        }
        setActive(v[0]);
    };

    const items: CollapseProps['items'] = useMemo(() => {
        return list.map((item, index) => {
            return {
                key: String(index),
                label: item.title,
                children: item.desc,
                ...(active === String(index) ? { collapsible: 'disabled' } : {}),
            };
        });
    }, [active]);
    const expandIcon = () => (
        <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path d="M18 9.5L12 15.5L6 9.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </span>
    );

    return (
        <div className={`${styles.triShield} GtmModuleData-section`} data-section-id={styles.triShield} data-section-title={t(`trishield_title`)}>
            <div className="content">
                <div className="text-container">
                    <h5 className="label">{t(`trishield_label`)}</h5>
                    <h2>{t(`trishield_title`)}</h2>
                    <p className="intro">{t(`trishield_intro`)}</p>
                </div>
                <div className="img-container">
                    <EFPicture src={img} alt={t(`trishield_title`)} className="banner" />
                    <div className="collapse-wrapper">
                        <Collapse
                            bordered={false}
                            expandIconPosition="end"
                            activeKey={active}
                            onChange={changeActive}
                            accordion
                            expandIcon={expandIcon}
                            items={items}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TriShield;
